var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('binds-table-head-selection'),_vm._l((_vm.BindsTable.items),function(item,index){return _c('binds-table-head',_vm._b({key:index},'binds-table-head',item,false))})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }